import styled from '@emotion/styled';
import theme from '../../theme';

export const CheckGroup = styled.span({
  display: 'block',
  position: 'relative',
});

export const Input = styled.input({
  position: 'absolute',
  padding: 0,
  margin: 0,
  height: 24,
  width: 24,
  backgroundColor: 'transparent',
  left: 0,
  top: 0,
  border: 'none',
  cursor: 'pointer',
  appearance: 'none',
  outline: 'none',
  zIndex: 3,

  '&:focus': {
    border: 'none',
    borderColor: 'transparent !important',
  },
  '&:focus ~ span:last-child': {
    borderColor: theme.colors.lightBlue,
  },
  '&:checked + span': {
    opacity: 1,
  },
  '&:checked ~ span:last-child::after': {
    opacity: 1,
  },

  '&.error ~ span:last-child': {
    borderColor: theme.colors.error,
  },
  '&[disabled] ~ span:last-child': {
    borderColor: theme.colors.darkBlue,
    opacity: theme.opacities.overlay, // TODO fix if needed
  },
});

export const CustomCheck = styled.span({
  position: 'absolute',
  top: 0,
  left: 0,
  height: 24,
  width: 24,
  border: `3px solid ${theme.colors.darkBlue}`,
  borderRadius: '50%',
  display: 'block',

  '&::after': {
    content: '\'\'',
    position: 'absolute',
    display: 'block',
    opacity: 0,
    top: 'calc(50% - 5px)',
    left: 'calc(50% - 5px)',
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: theme.colors.darkBlue,
  },
  '&.checkBox': {
    borderRadius: 0,
    '&::after': {
      height: 6,
      width: 10,
      top: 'calc(50% - 6px)',
      left: 'calc(50% - 6px)',
      borderBottom: `3px solid ${theme.colors.darkBlue}`,
      borderLeft: `3px solid ${theme.colors.darkBlue}`,
      backgroundColor: 'transparent',
      borderRadius: 0,
      opacity: 0,
      transform: 'rotate(-45deg)',
    },
  },
});
